export default __webpack_public_path__ + "static/media/views2.d6fea8e3.png";